var exports = {
  "k": "x112a1f60--8c6506--container",
  "L": "x112a1f60--8c6506--toggle",
};

module.exports = exports;
